import * as types from "../constants/actionConstants";
import {
    startQuestionnaireApi,
    completeQuestionnaireApi,
    getQuestionnaireInstanceIdFromRefKeyApi,
    getQuestionnaireReadonlyInstanceIdFromRefKeyApi,
    getQuestionnaireInstanceApi,
    getQuestionnaireFullApi,
    getNewTokenIdAfterExpiration,
    answerQuestionAnswerOptionsApi,
    answerQuestionTextApi,
    answerQuestionRankingApi
} from "../api/portalApi";
import * as system from "../constants/systemConstants";
import * as portalShared from "../shared/metadataConstantsAndUtilities";


export const startQuestionnaire = (id) => {
    return (dispatch) => {
        startQuestionnaireApi(id).then(response => {
            dispatch({
                type: types.QUESTIONNAIRE_START,
                data: response
            })
        })
    }
};

export const completeQuestionnaire = (id) => {
    return (dispatch) => {
        completeQuestionnaireApi(id).then(response => {
            dispatch({
                type: types.QUESTIONNAIRE_COMPLETE
            })
        })
    }
};

export const getQuestionnaire = (id, after = ()=>{}) => {
    return (dispatch) => {
        getQuestionnaireFullApi(id).then(questionnaire => {
            dispatch({
                type: types.QUESTIONNAIRE_GET_FULL_SUCCESS,
                id,
                questionnaire
            });
            //after();
        });
    };
};

export const setQuestionnaireTemplate = (questionnaireTemplate) => {
    return (dispatch) => {
        dispatch({
            type: types.SET_QUESTIONNAIRE_TEMPLATE_SUCCESS,
            data: {id: questionnaireTemplate.id, questionnaireTemplate: questionnaireTemplate}
        });
    };
};


export const setDataDefObj = (dataDefObj) => {
    return (dispatch) => {
        dispatch({
            type: types.SET_DATA_DEF_OBJ,
            data: {dataDefObj: dataDefObj}
        });
    };
};


export const setTemplateObj = (templateObj) => {
    return (dispatch) => {
        dispatch({
            type: types.SET_TEMPLATE_OBJ,
            data: {templateObj: templateObj}
        });
    };
};

export const clearPortalPreviewMode = () => {
    return (dispatch) => {
        dispatch({
            type: types.SET_QUESTIONNAIRE_TEMPLATE_NULL
        });
    };
};

export const getQuestionnaireInstance = (refKey, firstAnswerIndex) => {
    return (dispatch) => {
        getQuestionnaireInstanceIdFromRefKeyApi(refKey, firstAnswerIndex).then((data) => {
            localStorage.setItem(`${system.STORAGE_TOKEN}_${refKey}`, data[system.STORAGE_TOKEN]);
            dispatch({
                type: types.TOKEN_SET
            });
            dispatch({
                type: types.GET_QUESTIONNAIRE_INSTANCE_ID_FROM_REF_KEY_SUCCESS,
                data: {refKey: refKey, firstAnswerIndex: firstAnswerIndex, questionnaireId: data.questionnaireId, metadata: data.metadata}
            });
            getQuestionnaireInstanceApi(data.questionnaireId).then((data) => {
                dispatch({
                    type: types.GET_QUESTIONNAIRE_INSTANCE_SUCCESS,
                    data: data
                });
            });
        });
    };
};

export const getNewTokenId = (refKey) => {
    return(dispatch) => {
        getNewTokenIdAfterExpiration(refKey).then((newTokenId) => {
            localStorage.setItem(`${system.STORAGE_TOKEN}_${refKey}`, newTokenId);
            dispatch({
                type: types.TOKEN_SET
            });
        })
    }
};

export const getQuestionnaireReadonlyInstance = (refKey) => {
    return (dispatch) => {
        getQuestionnaireReadonlyInstanceIdFromRefKeyApi(refKey).then((data) => {
            localStorage.setItem(`${system.STORAGE_TOKEN}_${refKey}`, data[system.STORAGE_TOKEN]);
            dispatch({
                type: types.TOKEN_SET
            });
            dispatch({
                type: types.GET_QUESTIONNAIRE_INSTANCE_ID_FROM_REF_KEY_SUCCESS,
                data: {refKey: refKey, questionnaireId: data.questionnaireId, metadata: data.metadata}
            });
            getQuestionnaireInstanceApi(data.questionnaireId).then((data) => {
                dispatch({
                    type: types.GET_QUESTIONNAIRE_INSTANCE_SUCCESS,
                    data: data
                });
            });
        });
    };
};

export const setQuestionnaireInstanceNull = () => {
    return (dispatch) => {
        dispatch({
            type: types.SET_QUESTIONNAIRE_INSTANCE_NULL
        });
    };
};

export const currentPage = (currPage) => {
    return (dispatch) => {
        dispatch({
            type: types.PORTAL_CURRENT_PAGE,
            data: currPage
        });
    };
};

export const nextPage = (currPage) => {
    return (dispatch) => {
        dispatch({
            type: types.PORTAL_NEXT_PAGE,
            data: currPage
        });
    };
};

export const prevPage = (currPage) => {
    return (dispatch) => {
        dispatch({
            type: types.PORTAL_PREV_PAGE,
            data: currPage
        });
    };
};

export const answerQuestionOptions = (id, answerOptionKey, answerOptionUpdateDTO = ()=>{}, fromInputType, question) => {
    let thunk = (dispatch, getState) => {
        dispatch({type: types.QUESTION_ANSWER_SUCCESS, data: {id: id, key: answerOptionKey, responseObj: answerOptionUpdateDTO, fromInputType: fromInputType, question: question}});
        answerQuestionAnswerOptionsApi(id, answerOptionKey, answerOptionUpdateDTO).then(responseObj => {
            //dispatch(getQuestionnaire(getState().responseProcess.id, after));
            //dispatch({type: types.QUESTION_ANSWER_SUCCESS, data: {id: id, key: answerOptionKey, responseObj: responseObj}});
        });
    };

    thunk.meta = {
        debounce: {
            time: 400,
            key: "__sendAnswerCheck",
            leading: true,
            trailing: true
        }
    };

    return thunk;
};

export const answerQuestionRanking = (id, answers, answerKeys) => {
    let thunk = (dispatch, getState) => {
        dispatch({type: types.QUESTION_ANSWER_SUCCESS, data: {id: id, answers: answers}});
        answerQuestionRankingApi(id, answerKeys).then(responseObj => {
            //dispatch(getQuestionnaire(getState().responseProcess.id, after));
            //dispatch({type: types.QUESTION_ANSWER_SUCCESS, data: {id: id, key: answerOptionKey, responseObj: responseObj}});
        });
    };

    thunk.meta = {
        debounce: {
            time: 400,
            key: "__sendAnswerCheck",
            leading: true,
            trailing: true
        }
    };

    return thunk;
};

export const answerQuestionTemplateOptions = (id, answerOptionKey, answerOptionUpdateDTO = ()=>{}, fromInputType, question) => {
    return (dispatch) => {
        dispatch({type: types.QUESTION_TEMPLATE_ANSWER_SUCCESS, data: {id: id, key: answerOptionKey, responseObj: answerOptionUpdateDTO, fromInputType: fromInputType, question: question}});
    };
};

export const answerQuestionTemplateRanking = (id, answers) => {
    return (dispatch) => {
        dispatch({type: types.QUESTION_TEMPLATE_ANSWER_SUCCESS, data: {id: id, answers: answers}});
    };
};

export const unanswerQuestion = (question) => {

    switch(question.questionType) {
        case portalShared.FREE_TEXT:
        case portalShared.EMAIL:
        case portalShared.PHONE:
        case portalShared.NUMBER:
        case portalShared.CURRENCY:
        case portalShared.DATE:
        case portalShared.DATE_RANGE:
        case portalShared.ZIPPOSTAL_ONLY:
            if (question.answerText) {
                answerQuestionTextApi(question.id, {answerText: ""}).then(responseObj => {
                    let response = responseObj;
                });
            }
            break;
        case portalShared.RADIO:
        case portalShared.YES_NO:
        case portalShared.STATE_ONLY:
        case portalShared.LIKERT_RADIO:
        case portalShared.CHECKBOX:

            for (let i = 0; i < question.answerOptions.length; i++) {
                if (question.answerOptions[i].selected) {
                    answerQuestionAnswerOptionsApi(question.id, question.answerOptions[i].key, {selected: false}).then(responseObj => {
                        let response = responseObj;
                    });
                }
            }

            break;
        case portalShared.ADDRESS_FULL:
            if (question.addressAnswerDTO) {
                answerQuestionTextApi(question.id, {addressAnswerDTO: null}).then(responseObj => {
                    let response = responseObj;
                });
            }

            // State
            for (let i = 0; i < question.answerOptions.length; i++) {
                if (question.answerOptions[i].selected) {
                    answerQuestionAnswerOptionsApi(question.id, question.answerOptions[i].key, {selected: false}).then(responseObj => {
                        let response = responseObj;
                    });
                }
            }

            break;
        case portalShared.RANKING:
            answerQuestionRankingApi(question.id, {answerRanking: []}).then(responseObj => {
                let response = responseObj;
            });
            break;
        default:
            // Unanswer API
            break;
    }



};

export const answerQuestionText = (question, questionUpdateDTO = ()=>{}, fromInputType, callerRefStr) => {
    return (dispatch) => {
        answerQuestionTextApi(question.id, questionUpdateDTO).then(responseObj => {
            dispatch({type: types.QUESTION_ANSWER_SUCCESS, data: {id: question.id, key: null, responseObj: responseObj, fromInputType: fromInputType, question: question, callerRefStr: callerRefStr}});
            //dispatch(getQuestionnaire(getState().responseProcess.id, after))
        });
    };
};

export const answerQuestionTextInStore = (question, answerText, fromInputType, callerRefStr) => {
    return (dispatch) => {
            dispatch({type: types.QUESTION_ANSWER_SUCCESS,
                      data: {id: question.id, key: null, responseObj: answerText, fromInputType: fromInputType, question: question, callerRefStr: callerRefStr}});
    };
};

export const answerQuestionTemplateText = (question, questionUpdateDTO = ()=>{}, fromInputType, callerRefStr) => {
    return (dispatch) => {
        dispatch({
            type: types.QUESTION_TEMPLATE_ANSWER_SUCCESS,
            data: {id: question.id, key: null, responseObj: questionUpdateDTO, fromInputType: fromInputType, question: question, callerRefStr: callerRefStr}
        });
    };
};

export const onChangeQuestionText = (question, id, value, helperText) => {
    return (dispatch) => {
        dispatch({type: types.PORTAL_ON_CHANGE_TEXT_ENTRY, data: {question: question, id: id, value: value, helperText: helperText}});
    };
};


export const incrementPortalCount = () => {
    return (dispatch) => {
        dispatch({
            type: types.INCREMENT_PORTAL_COUNT
        });
    };
};




